// extracted by mini-css-extract-plugin
export default {"button-wrapper":"LanguageButton_button-wrapper__3tcog","button":"LanguageButton_button__qIZta"};